import React from 'react';
import Input from '../../UI/Input';

interface QuickValueUpdateProps {
  currentValue: number;
  onValueChange: (newValue: number) => void;
  className?: string;
}

const QuickValueUpdate: React.FC<QuickValueUpdateProps> = ({
  currentValue,
  onValueChange,
  className = '',
}) => {
  return (
    <Input
      type="number"
      value={currentValue.toString()}
      onChange={(e) => {
        const newValue = parseFloat(e.target.value) || 0;
        onValueChange(newValue);
      }}
      className={`w-24 text-sm ${className}`}
      placeholder="Value"
    />
  );
};

export default QuickValueUpdate;

